/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLocalesResult } from '../../models/get-locales-result';

export interface ApiLanguagesLocalesGet$Params {
}

export function apiLanguagesLocalesGet(http: HttpClient, rootUrl: string, params?: ApiLanguagesLocalesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocalesResult>> {
  const rb = new RequestBuilder(rootUrl, apiLanguagesLocalesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLocalesResult>;
    })
  );
}

apiLanguagesLocalesGet.PATH = '/api/Languages/locales';
